import http from "@/utils/request"

export default {
  getInfoByUserName: {
    url: 'system/systemCustom/getInfoByUserName',
    name: '根据用户名获取基本配置',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  login: {
    url: 'oms/login',
    name: '登录',
    post: async function(data, config={headers:{'Content-Type': 'application/json;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  }
}
